import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
export const ItemNotFound = ({ itemName }: { itemName: string }) => {
  const navigate = useNavigate();

  return (
    <div className={`flex items-center justify-center h-screen flex-col align-middle gap-8`}>
      <div className="text-9xl text-[#CAC8C8] font-bold">404</div>
      <div className="flex flex-col gap-3 text-center ">
        <h1 className="leading-10 text-[32px] font-normal text-black">{`Oops! The ${itemName} is not found`}</h1>
      </div>

      <Button variant="default" className="w-fit px-4 cursor-pointer" onClick={() => navigate(-1)}>
        Go Back
      </Button>
    </div>
  );
};
